<template>
  <div class="app">
    <!--登录view需要缓存，从二次验证切换回的时候，需要保留状态-->
    <login v-show="currentView=='login'" @changeToVerify="changeToVerify" @changeToError="changeToError" @changeToMode="changeToMode" ref="login" />
    <!--二次验证view不需要缓存-->
    <verify v-if="currentView=='verify'" @changeToLogin="changeToLogin" :un="un" :ppdata="ppdata" />
    <!--错误页，不需要缓存-->
    <errorpage v-if="currentView=='error'" :errMsg="errMsg" />
    <mode v-if="currentView==='mode'" :mode="modeData" @backLogin="changeToLogin" :toUrl="toUrl"></mode>
  </div>
</template>

<script>
import util from './util/util';

export default {
    name: 'app',
    data() {
        return {
            currentView: 'login',
            un: '',
            errMsg: '未知错误',
            modeData:{},
            toUrl:''
        };
    },
    watch: {
        currentView(val, oldVal) {
            // 重新进入login view不需要loading
            if (val !== 'login') {
                window.Loading.loading = true;
            }
        }
    },

    created() {
      this.showPage();
    },

    methods: {
        /**
         * 切换至二次验证模块
         */
        changeToVerify(opts) {
            this.currentView = 'verify';
            this.un = opts.un;
            this.ppdata = opts.data;
        },
        /**
         * 切换至登录模块
         */
        changeToLogin(data) {
            this.currentView = 'login';
            if (!!data.autoLogin) {
                // 调用自动登录方法
                this.$refs.login.getTicket();
            }
            if (data.errMsg) {
                if ( data.ret === '454' ){
                    data.errMsg.opt.confirm = util.createConfirm(data.un)
                }
                if ( data.ret === '452' ){
                    data.errMsg.opt.confirm = util.createLogoutConfirm(data.un)
                }
                window.showError(data.errMsg);
                // @NOTE 和交互确认 不重新初始化
            }
        },
        /**
         * 切换至错误模块
         */
        changeToError(errMsg) {
            this.currentView = 'error';
            this.errMsg = errMsg;
        },
      changeToMode (mode,toUrl) {
        this.currentView = 'mode'
        this.modeData = mode
        this.toUrl = toUrl
      },

      showPage () {
        try {
            // 回退刷新页面
            window.addEventListener( `pageshow`, function ( event ) {
                if ( ( event && event.persisted ) || ( window.performance && window.performance.navigation &&
                    window.performance.navigation.type === 2 ) ){
                    location.reload()
                }
            }, false )
        // eslint-disable-next-line no-empty
        } catch ( e ){}
      }
    }
};
</script>

<style lang=scss>
@import './scss/reset';
html {
    background-color: $bg_page;
    font-size: 50px;
    /*height:100%;overflow:hidden;*/
}
body {
    font-size: 0.28rem;
    /*position: fixed;*/
    /*height:100%;overflow:hidden;*/
}
body .app {
    max-width: 500px;
    margin: 0 auto;
}
body > #app {
    position: relative;
    max-width: 10rem;
    margin: 0 auto;
    overflow: hidden;
}

/* 头部样式 */
.g-hd {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    .u-logo {
        display: block;
        margin: 0 auto;
        height: 0.8rem;
    }
    &.hd-you {
        padding: 0;
        a {
            display: block;
            width: 100%;
        }
        .u-logo {
            width: 100%;
            height: auto;
        }
    }
}
/* 主体样式 */
.g-bd {
    display: block;
    position: relative;
}

/* 底部样式 */
.g-ft {
    display: block;
}

/* 公共边界 */
.g-pd {
    padding-left: 0.4rem;
    padding-right: 0.4rem;
}

/* 邮箱广告位 */
.g-mail-ad {
    margin-top: 80px;
    width: 100%;
    max-width: 500px;
    text-align: center;
    color: #0d70ff;
    a {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        margin-bottom: 10px;
    }
    @media screen and (max-width: 320px) {
        margin-top: 50px;
        font-size: 12px;
    }
    /* 横屏时不能使用绝对定位 */
    @media screen and (orientation: landscape) {
        margin-top: 100px;
    }
}

@media screen and (min-width: 500px) {
    .g-pd {
        padding-left: 0;
        padding-right: 0;
    }
}

/* loading */
.g-loading {
    display: block;
    position: absolute;
    top: 0;
    z-index: 1999;
    height: 100%;
    width: 100%;
    background-color: $bg_page;
    .m-loading1 {
        position: fixed;
        top: 3rem;
        left: 50%;
        margin-left: -25px;
    }
    .u-error-flag {
        display: block;
        margin: 40px auto 20px;
    }
    .u-error-info {
        text-align: center;
        font-size: 18px;
        margin: 20px 0 40px 0;
    }
    & > .u-btn {
        width: 100%;
        button {
            display: block;
            width: 85%;
            margin: 0 auto;
        }
    }
}

/* 浮动 */
.f-left {
    float: left;
}
.f-right {
    float: right;
}
.clearboth {
    clear: both;
}

.f-cf {
    @extend .clearfix;
}
.f-dn {
    display: none !important;
}

@import './scss/common.scss';
@import './scss/form.scss';
@import './scss/button.scss';
@import './scss/sprite.scss';

/*.c-main{
  >button{
    background: red !important;
  }
  >a{
    color: red !important;
    &:hover,&:active{
      color: red !important;
    }
  }
  >strong{
    color: red !important;

  }
  &.u-btn-sms{
    >button{
      color: red !important;
      background: white !important;
      border-left: 1px solid #d0d0d0 !important;
    }
  }
  .i-checkbox{
    &.checked{background-color:{mainColor} !important;}
  }
}*/
</style>



// WEBPACK FOOTER //
// App.vue?de9415a2